<template>
  <div>
    <div class="vue-step-wrapper">
      <vue-step
        style-type="style2"
        active-color="#4ce595"
        :now-step="4"
        :step-list="[
          $t('newAction.stepsLabels.selectMetric'),
          $t('newAction.stepsLabels.stepOne'),
          $t('newAction.stepsLabels.stepTwo'),
          $t('newAction.stepsLabels.stepThree'),
        ]"
      ></vue-step>
    </div>
    <div v-show="!loadingPage" class="wrapper">
      <div class="header mt-2">
        <span class="header-icon-qrcode">
          <i class="fas fa-qrcode"></i>
        </span>
        <span class="qrcode-title">{{
          $t('newAction.stepThree.generateQrCode')
        }}</span>
      </div>
      <div class="main-qrcode">
        <b-form-radio-group v-model="selected" v-slot="{ ariaDescribedby }">
          <b-form-radio
            value="unique"
            name="unique"
            style="text-transform: uppercase;"
            :aria-describedby="ariaDescribedby"
            ><span style="font-size: 20px;">{{
              $t('newAction.stepThree.uniqueQrCode')
            }}</span></b-form-radio
          >
          <b-form-radio
            value="multiple"
            name="multiple"
            style="text-transform: uppercase;"
            :aria-describedby="ariaDescribedby"
            ><span style="font-size: 20px;">{{
              $t('newAction.stepThree.multipleQrCode')
            }}</span></b-form-radio
          >
        </b-form-radio-group>

        <template>
          <div id="template-unique">
            <div style="display: flex;">
              <canvas id="canvas"></canvas>
              <div style="padding-top: 50px;">
                <p>
                  <strong>{{ $t('newAction.stepThree.uniqueQrCode') }}</strong>
                </p>
                <p>
                  {{ $t('newAction.stepThree.uniqueQrCodeDescription') }}
                </p>
                <button
                  class="btn btn-outline-primary"
                  @click="generateUniqueQrCode()"
                >
                  {{ $t('newAction.stepThree.downloadQrCode') }}
                </button>
                <button
                  style="margin-left: 20px;"
                  class="btn btn-outline-primary"
                  @click="copiarUrlQrCodeUnique()"
                >
                  Copiar Link QR Code
                </button>
              </div>
            </div>
          </div>
        </template>
        <template>
          <div id="template-multiple">
            <p style="margin-top: 20px;">
              <strong>{{ $t('newAction.stepThree.multipleQrCode') }}</strong>
            </p>
            <p>
              {{ $t('newAction.stepThree.multipleQrCodeDescription') }}
            </p>

            <div class="row">
              <div class="col-12">
                <idx-card
                  :title="`${this.$t('newAction.stepThree.titleIndicators')}`"
                >
                  <div class="row mb-2 no-gutters">
                    <div class="col-3">
                      <label for
                        >{{
                          $t('newAction.stepThree.labels.addIndicators')
                        }}:</label
                      >
                      <input
                        v-model="columnName"
                        type="text"
                        class="form-control mt-2"
                        :placeholder="`${this.$t(
                          'newAction.stepThree.enterIndicatorsName',
                        )}`"
                        @keyup.enter="addColumn"
                        :disabled="sending"
                      />
                    </div>
                    <div class="col-9">
                      <div class="drop-indicators">
                        <button
                          class="btn btn-primary"
                          style="margin-top: 39px; margin-left: -17px;"
                          @click="addColumn"
                        >
                          {{ $t('newAction.stepThree.buttonAddColumn') }}
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <hr />
                      <span
                        >{{ $t('newAction.stepThree.addedIndicators') }}:</span
                      >
                      <table class="table table-striped mt-3">
                        <thead>
                          <tr>
                            <th scope="col">
                              {{ $t('newAction.stepThree.indicator') }}
                            </th>
                            <th
                              scope="col"
                              class="indicator-th"
                              v-for="(indicatorHeader, i) in indicatorHeaders"
                              :key="i"
                            >
                              {{ indicatorHeader.header }}
                              <span
                                :id="indicatorHeader.header"
                                class="indicator-info-icon"
                              >
                                <font-awesome-icon
                                  :icon="['fas', 'info-circle']"
                                  style="font-size: 15px; color: #c1c1c1;"
                                />
                              </span>
                              <b-popover
                                :target="indicatorHeader.header"
                                :title="indicatorHeader.header"
                                triggers="hover"
                                placement="top"
                                :content="indicatorHeader.content"
                              ></b-popover>
                            </th>
                            <th scope="col">
                              {{ $t('newAction.stepThree.remove') }}
                            </th>
                          </tr>
                        </thead>
                        <draggable
                          v-model="indicators"
                          tag="tbody"
                          id="dtable"
                          @change="handleSort"
                        >
                          <tr
                            v-for="(indicator, index) in indicators"
                            :key="index"
                          >
                            <td>
                              <font-awesome-icon
                                :icon="['fas', 'ellipsis-v']"
                                class="ellipsis"
                              />
                              {{ indicator.label }}
                            </td>
                            <td>
                              <b-form-checkbox
                                @input="
                                  indicatorRules('ih1', indicator.id, $event)
                                "
                                v-model="indicator.ih1"
                                :disabled="
                                  (allIh1Disabled && !indicator.ih1) ||
                                  indicator.ih2 ||
                                  indicator.map ||
                                  indicator.date ||
                                  indicator.auxiliary ||
                                  indicator.clientId
                                "
                              ></b-form-checkbox>
                            </td>
                            <td>
                              <b-form-checkbox
                                @input="
                                  indicatorRules('ih2', indicator.id, $event)
                                "
                                v-model="indicator.ih2"
                                :disabled="
                                  (allIh2Disabled && !indicator.ih2) ||
                                  indicator.ih1 ||
                                  indicator.map ||
                                  indicator.date ||
                                  indicator.auxiliary ||
                                  indicator.clientId
                                "
                              ></b-form-checkbox>
                            </td>
                            <td>
                              <b-form-checkbox
                                @input="
                                  indicatorRules('report', indicator.id, $event)
                                "
                                v-model="indicator.report"
                                :disabled="
                                  indicator.auxiliary || indicator.clientId
                                "
                              ></b-form-checkbox>
                            </td>
                            <td>
                              <b-form-checkbox
                                @input="
                                  indicatorRules('map', indicator.id, $event)
                                "
                                v-model="indicator.map"
                                :disabled="
                                  (allMapDisabled && !indicator.map) ||
                                  indicator.ih1 ||
                                  indicator.ih2 ||
                                  indicator.date ||
                                  indicator.auxiliary ||
                                  indicator.clientId
                                "
                              ></b-form-checkbox>
                            </td>
                            <td>
                              <b-form-checkbox
                                @input="
                                  indicatorRules('date', indicator.id, $event)
                                "
                                v-model="indicator.date"
                                :disabled="
                                  indicator.ih1 ||
                                  indicator.ih2 ||
                                  indicator.map ||
                                  indicator.clientId
                                "
                              ></b-form-checkbox>
                            </td>
                            <td>
                              <b-form-checkbox
                                @input="
                                  indicatorRules(
                                    'auxiliary',
                                    indicator.id,
                                    $event,
                                  )
                                "
                                v-model="indicator.auxiliary"
                                :disabled="
                                  indicator.ih1 ||
                                  indicator.ih2 ||
                                  indicator.report ||
                                  indicator.map ||
                                  indicator.clientId
                                "
                              ></b-form-checkbox>
                            </td>
                            <td>
                              <b-form-checkbox
                                :onclick="
                                  habilitAnonymous(
                                    indicator.id,
                                    indicator.clientId,
                                  )
                                "
                                @input="
                                  indicatorRules(
                                    'clientId',
                                    indicator.id,
                                    $event,
                                  )
                                "
                                v-model="indicator.clientId"
                                :disabled="
                                  (allClientIdDisabled &&
                                    !indicator.clientId) ||
                                  indicator.ih1 ||
                                  indicator.ih2 ||
                                  indicator.map ||
                                  indicator.date ||
                                  indicator.auxiliary
                                "
                              ></b-form-checkbox>
                            </td>
                            <td>
                              <b-form-checkbox
                                :disabled="indicator.clientId"
                                @input="
                                  indicatorRules(
                                    'anonymous',
                                    indicator.id,
                                    $event,
                                  )
                                "
                                v-model="indicator.anonymous"
                              ></b-form-checkbox>
                            </td>
                            <td>
                              <button
                                @click="removeColumn(index, indicator.id)"
                                class="btn btn-outline-danger"
                              >
                                <font-awesome-icon
                                  :icon="['fa', 'trash-alt']"
                                />
                              </button>
                            </td>
                          </tr>
                        </draggable>
                      </table>
                    </div>
                  </div>
                </idx-card>
              </div>
            </div>
            <div class="row mt-5">
              <div class="col-12">
                <idx-card
                  :title="`${this.$t('newAction.stepThree.titleLayout')}`"
                >
                  <div class="row mb-4">
                    <div class="col-12 text-right">
                      <button
                        @click="downloadModel"
                        class="btn btn-primary mr-2"
                        :disabled="sending"
                      >
                        <font-awesome-icon :icon="['fas', 'download']" />
                        {{ $t('newAction.stepThree.downloadModelButton') }}
                      </button>
                      <button
                        class="btn btn-outline-danger"
                        :title="`${this.$t(
                          'newAction.stepThree.titleClearTable',
                        )}`"
                        @click="cleanTable"
                      >
                        <font-awesome-icon :icon="['fa', 'trash-alt']" />
                      </button>
                    </div>
                  </div>
                  <div class="row mt-2">
                    <div class="col-12">
                      <div v-if="loading" class="text-center">
                        <b-spinner
                          variant="success"
                          type="grow"
                          label="Spinning"
                          class="bg-primary"
                        ></b-spinner>
                      </div>
                      <b-table
                        v-else
                        id="table-items"
                        striped
                        responsive
                        :fields="indicators"
                        :items="insertedItems"
                        :per-page="perPage"
                        :current-page="currentPage"
                      >
                      </b-table>
                      <div class="mt-4 mb-4">
                        <b-pagination
                          v-model="currentPage"
                          :total-rows="insertedItems.length"
                          :per-page="perPage"
                          aria-controls="table-items"
                        ></b-pagination>
                      </div>
                    </div>
                  </div>
                </idx-card>
              </div>
            </div>
            <div v-if="this.checkQuota" class="col-12 text-center">
              <b-spinner
                variant="success"
                type="grow"
                label="Spinning"
                class="bg-primary"
              ></b-spinner>
            </div>
            <div v-else class="row mt-5">
              <div class="col-8">
                <idx-card
                  :title="`${this.$t('newAction.stepThree.titleImportData')}`"
                >
                  <div class="row">
                    <div class="col-8">
                      <p>{{ $t('newAction.stepThree.importValueQrCode') }}:</p>
                      <b-form-file
                        :browse-text="`${this.$t(
                          'newAction.stepThree.importFile',
                        )}`"
                        :placeholder="`${this.$t(
                          'newAction.stepThree.dragFile',
                        )}`"
                        :drop-placeholder="`${this.$t(
                          'newAction.stepThree.dropFile',
                        )}`"
                        v-model="submitFile"
                      ></b-form-file>
                      <div class="text-right" style="padding: 5px 0;"></div>
                    </div>
                    <div class="col-4">
                      <div class="text-center">
                        <span
                          >{{
                            $t('newAction.stepThree.enterValueManually')
                          }}:</span
                        >
                        <br />
                        <button
                          class="btn btn-outline-primary mt-3"
                          v-b-modal.modal-add-user
                        >
                          <font-awesome-icon :icon="['fa', 'user-plus']" />
                        </button>
                      </div>
                      <b-modal
                        id="modal-add-user"
                        size="lg"
                        :title="`${this.$t(
                          'newAction.stepThree.titleImportData',
                        )}`"
                        @ok="insertItem"
                      >
                        <form id="frm-newUser">
                          <div v-for="(indicator, i) in indicators" :key="i">
                            <div class="form-group row">
                              <label
                                :for="indicator.key"
                                class="col-sm-2 col-form-label"
                              >
                                {{ indicator.label }}
                              </label>
                              <div class="col-sm-10">
                                <input
                                  type="text"
                                  class="form-control"
                                  :name="`${indicator.key}`"
                                  :placeholder="
                                    $t('newAction.stepThree.informFieldPhone', {
                                      data: `${indicator.label}`,
                                    })
                                  "
                                />
                              </div>
                            </div>
                          </div>
                        </form>
                      </b-modal>
                      <b-toast
                        id="example-toast"
                        title="BootstrapVue"
                        static
                        no-auto-hide
                        >{{
                          $t('newAction.stepThree.failedAddCustomer')
                        }}</b-toast
                      >
                    </div>
                  </div>
                </idx-card>
              </div>
              <div class="col-4">
                <button
                  class="btn btn-primary"
                  style="
                    margin-left: 35%;
                    margin-top: 25px;
                    width: 38%;
                    color: #fff;
                  "
                  @click="generateQrcodes"
                  :disabled="insertedItems.length === 0"
                >
                  {{ $t('newAction.stepThree.generateQrCodeButton') }}
                </button>
                <button
                  class="btn btn-primary"
                  style="
                    margin-left: 35%;
                    margin-top: 10px;
                    width: 38%;
                    color: #fff;
                  "
                  @click="
                    routerPath(`/action/generate-all-qr-code/${action._id}`)
                  "
                  :disabled="disabledButton"
                >
                  {{ $t('newAction.stepThree.viewQrCodes') }}
                </button>
              </div>
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-12 footer-buttons-area">
              <button @click="$router.back()" class="btn btn-info">
                {{ $t('genericMessages.goBack') }}
              </button>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import serialize from 'form-serialize';
import QRCode from 'qrcode';
import IdxCard from '@/components/molecules/idx-card';
import { mapFields } from 'vuex-map-fields';
import draggable from 'vuedraggable';
import vueStep from 'vue-step';
import swal from 'sweetalert';
import XLSX from 'xlsx';
import api from '../../../../services/api';

export default {
  components: { IdxCard, draggable, vueStep },

  watch: {
    submitFile: function watchFile(file) {
      if (file) {
        this.loadTextFromFile(file);
      }
    },

    selected: async function watchSelected() {
      if (this.selected === 'unique') {
        const multiple = document.getElementById('template-multiple');
        const unique = document.getElementById('template-unique');

        multiple.style.display = 'none';
        unique.style.display = 'block';

        await api.put(
          `/action/${this.$route.params.id}`,
          {
            qrcodeType: this.selected,
          },
          {
            headers: {
              'x-access-token': this.userAuth.token,
            },
          },
        );
      } else {
        const multiple = document.getElementById('template-multiple');
        const unique = document.getElementById('template-unique');

        multiple.style.display = 'block';
        unique.style.display = 'none';

        await api.put(
          `/action/${this.$route.params.id}`,
          {
            qrcodeType: this.selected,
          },
          {
            headers: {
              'x-access-token': this.userAuth.token,
            },
          },
        );
      }
    },
  },

  computed: {
    ...mapFields('actions', ['action']),

    ...mapFields('submit', ['submitFile']),

    domainUrl() {
      let domain = 'https://app-indecx.com';

      if (window.location.hostname === 'localhost') {
        domain = 'http://localhost:8080';
      } else if (window.location.hostname === 'indecx.pe') {
        domain = 'https://indecx.pe';
      } else if (window.location.hostname === 'stg.idcx-verse.com') {
        domain = 'https://stg.idcx-verse.com';
      }

      return domain;
    },
  },

  data: () => ({
    userAuth: null,
    loading: false,
    columnName: null,
    sending: false,
    responseIndicators: [],
    indicators: [],
    indicatorHeaders: [],
    columns: [],
    insertedItems: [],
    selected: 'unique',
    allIh1Disabled: false,
    allMapDisabled: false,
    allIh2Disabled: false,
    allClientIdDisabled: false,
    checkQuota: false,
    perPage: 10,
    currentPage: 1,
    disabledButton: true,
    loadingPage: false,
  }),

  async created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));

    this.loadingPage = true;

    const response = await api.get(`/action/${this.$route.params.id}`, {
      headers: {
        'x-access-token': this.userAuth.token,
      },
    });

    this.selected = response.data.qrcodeType;

    this.action = { ...response.data };

    this.showUniqueQrCode();

    await this.getIndicators();

    this.loadingPage = false;

    this.indicatorHeaders = [
      {
        header: this.$t('newAction.stepThree.indicatorHeaders.filial.header'),
        content: this.$t('newAction.stepThree.indicatorHeaders.filial.content'),
      },
      {
        header: this.$t('newAction.stepThree.indicatorHeaders.ih2.header'),
        content: this.$t('newAction.stepThree.indicatorHeaders.ih2.content'),
      },
      {
        header: this.$t('newAction.stepThree.indicatorHeaders.report.header'),
        content: this.$t('newAction.stepThree.indicatorHeaders.report.content'),
      },
      {
        header: this.$t('newAction.stepThree.indicatorHeaders.map.header'),
        content: this.$t('newAction.stepThree.indicatorHeaders.map.content'),
      },
      {
        header: this.$t('newAction.stepThree.indicatorHeaders.date.header'),
        content: this.$t('newAction.stepThree.indicatorHeaders.date.content'),
      },
      {
        header: this.$t(
          'newAction.stepThree.indicatorHeaders.auxiliary.header',
        ),
        content: this.$t(
          'newAction.stepThree.indicatorHeaders.auxiliary.content',
        ),
      },
      {
        header: this.$t('newAction.stepThree.indicatorHeaders.clientId.header'),
        content: this.$t(
          'newAction.stepThree.indicatorHeaders.clientId.content',
        ),
      },
      {
        header: 'Anonimizar',
        content:
          'Ao selecionar você pode visualizar ou não os indicadores de respostas anonimas',
      },
    ];

    const responseQrCode = await api.get(`/qrcodes/${this.action._id}`, {
      headers: { 'x-access-token': this.userAuth.token },
    });

    if (responseQrCode.data === null) {
      this.disabledButton = true;
    } else {
      this.disabledButton = false;
    }
  },

  methods: {
    ...mapActions('actions', ['downloadQrcodeFile']),

    ...mapActions('indicators', [
      'setIndicators',
      'addTypeToIndicator',
      'removeTypeFromIndicator',
      'sortIndicator',
      'deleteIndicator',
    ]),

    habilitAnonymous(indicatorId, clientIdEnabled) {
      if (clientIdEnabled) {
        this.indicators.forEach((el) => {
          if (el.id === indicatorId) {
            el.anonymous = true;
          }
        });
      }
    },

    async getIndicators() {
      const indicators = await api.get(`/indicator/${this.action._id}`, {
        headers: {
          'x-access-token': this.userAuth.token,
        },
      });

      this.responseIndicators = indicators.data;

      this.checkIndicators();

      this.columns = this.indicators.map((el) => el.key);
    },

    async addColumn() {
      const regex = /^(?=.*[.$])/; // mongo issue -> key does not allow "." or "$"

      if (this.columnName) {
        if (regex.test(this.columnName)) {
          this.columnName = null;
          this.makeToastInvalidName();

          return;
        }

        if (this.columnName.toLowerCase() === 'id') {
          this.columnName = null;
          this.makeToastInvalidNameId();

          return;
        }

        const indicatorExists = this.indicators.findIndex(
          (obj) => obj.label === this.columnName,
        );

        if (indicatorExists < 0) {
          this.sending = true;
          this.loading = true;

          try {
            await this.setIndicators({
              token: this.userAuth.token,
              actionId: this.action._id,
              companyId: this.userAuth.companyId,
              data: {
                name: this.columnName,
              },
            });

            await this.getIndicators();

            this.columnName = null;
          } catch (error) {
            window.console.log(error);
          }

          this.sending = false;
          this.loading = false;
        } else {
          this.columnName = null;
          this.makeToastColumnName();
        }
      } else {
        this.columnName = null;
        this.makeToastColumnName();
      }
    },

    async indicatorRules(type, indicatorId, isChecked) {
      if (indicatorId) {
        try {
          if (isChecked) {
            if (type === 'ih1') {
              this.allIh1Disabled = true;
            }

            if (type === 'map') {
              this.allMapDisabled = true;
            }

            if (type === 'ih2') {
              this.allIh2Disabled = true;
            }

            if (type === 'clientId') {
              this.allClientIdDisabled = true;
            }

            if (type === 'anonymous') {
              this.anonymousDisabled = false;
            }

            await this.addTypeToIndicator({
              token: this.userAuth.token,
              indicatorId,
              type,
            });
          } else {
            if (type === 'ih1') {
              this.allIh1Disabled = false;
            }

            if (type === 'map') {
              this.allMapDisabled = false;
            }

            if (type === 'ih2') {
              this.allIh2Disabled = false;
            }

            if (type === 'clientId') {
              this.allClientIdDisabled = false;
            }

            if (type === 'anonymous') {
              this.anonymousDisabled = false;
            }

            await this.removeTypeFromIndicator({
              token: this.userAuth.token,
              indicatorId,
              type,
            });
          }
        } catch (error) {
          const myIndicator = this.indicators.find(
            (el) => el.id === indicatorId,
          );

          myIndicator[type] = !isChecked;

          swal({
            title: this.$t('newAction.stepThree.messages.dangerMode.title'),
            text: this.$t(
              'newAction.stepThree.messages.dangerMode.description',
            ),
            icon: 'error',
            dangerMode: true,
          });
        }
      }
    },

    async removeColumn(index, indicatorId) {
      swal({
        title: this.$t('newAction.stepThree.messages.removeColumn.title'),
        text: this.$t('newAction.stepThree.messages.removeColumn.description'),
        icon: 'warning',
        buttons: true,
        dangerMode: true,
      }).then(async (willDelete) => {
        if (willDelete) {
          await this.deleteIndicator({
            token: this.userAuth.token,
            indicatorId,
          });

          await this.getIndicators();

          swal({
            title: this.$t('newAction.stepThree.messages.success.title'),
            text: this.$t('newAction.stepThree.messages.success.description'),
            icon: 'success',
          });
        }
      });
    },

    async checkIndicators() {
      this.indicators = [];

      this.responseIndicators.forEach((el) => {
        this.indicators.push({
          key: el.key,
          position: el.position,
          label: el.name,
          ih1: el.types.indexOf('ih1') === -1 ? false : true,
          ih2: el.types.indexOf('ih2') === -1 ? false : true,
          report: el.types.indexOf('report') === -1 ? false : true,
          map: el.types.indexOf('map') === -1 ? false : true,
          date: el.types.indexOf('date') === -1 ? false : true,
          auxiliary: el.types.indexOf('auxiliary') === -1 ? false : true,
          clientId: el.types.indexOf('clientId') === -1 ? false : true,
          anonymous:
            el.types.indexOf('anonymous') === -1 ? el.anonymous : el.anonymous,
          id: el._id,
        });
      });

      const ih1Exists = this.indicators.find((el) => el.ih1);

      if (ih1Exists) {
        this.allIh1Disabled = true;
      }

      const mapExists = this.indicators.find((el) => el.ih1);

      if (mapExists) {
        this.allMapDisabled = true;
      }

      const ih2Exists = this.indicators.find((el) => el.ih2);

      if (ih2Exists) {
        this.allIh2Disabled = true;
      }

      const clientIdExists = this.indicators.find((el) => el.clientId);

      if (clientIdExists) {
        this.allClientIdDisabled = true;
      }
    },

    async handleSort() {
      await this.sortIndicator({
        token: this.userAuth.token,
        companyId: this.userAuth.companyId,
        indicators: this.indicators,
      });

      this.loading = true;

      this.getIndicators();

      this.loading = false;
    },

    async loadTextFromFile(file) {
      const reader = new FileReader();

      try {
        reader.readAsArrayBuffer(file);

        reader.onload = async (e) => {
          const data = new Uint8Array(e.target.result);
          const arr = [];

          for (let i = 0; i !== data.length; i += 1) {
            arr[i] = String.fromCharCode(data[i]);
          }

          const bstr = arr.join('');

          const workbook = XLSX.read(bstr, {
            type: 'binary',
          });

          const firstSheetName = workbook.SheetNames[0];

          const worksheet = workbook.Sheets[firstSheetName];

          const json = XLSX.utils.sheet_to_json(worksheet, {
            raw: true,
          });

          this.insertedItems = json;
        };
      } catch (err) {
        window.console.log(err);
      }
    },

    async generateQrcodes() {
      await api.post(
        `/qrcodes/${this.action._id}`,
        { indicators: this.insertedItems },
        { headers: { 'x-access-token': this.userAuth.token } },
      );
      this.$router.push(`/action/generate-all-qr-code/${this.action._id}`);
    },

    async showUniqueQrCode() {
      const canvas = document.getElementById('canvas');

      const idAction = this.action._id;

      const url = `${this.domainUrl}/survey-qrcode/${idAction}`;

      // eslint-disable-next-line func-names
      QRCode.toCanvas(canvas, url, { width: 500, height: 500 }, function (
        error,
      ) {
        if (error) window.console.error(error);
      });

      if (!this.action._id) {
        this.checkIndicators();
      }
    },

    copiarUrlQrCodeUnique() {
      const idAction = this.action._id;

      const urlInput = document.createElement('input');
      document.body.appendChild(urlInput);
      const url = `${this.domainUrl}/survey-qrcode/${idAction}`;
      urlInput.value = url;
      urlInput.select();
      document.execCommand('copy');
      document.body.removeChild(urlInput);

      this.$bvToast.toast(
        'O link do QR Code foi copiado para a área de transferência.',
        {
          title: this.$t('resend.messages.copyUrl.title'),
          autoHideDelay: 3000,
          variant: 'success',
          solid: true,
        },
      );
    },

    generateUniqueQrCode() {
      const canvas = document.getElementById('canvas');

      const idAction = this.action._id;

      const url = `${this.domainUrl}/survey-qrcode/${idAction}`;

      // eslint-disable-next-line func-names
      QRCode.toCanvas(canvas, url, { width: 500, height: 500 }, function (
        error,
      ) {
        if (error) window.console.error(error);
        const image = canvas
          .toDataURL('image/png')
          .replace('image/png', 'image/octet-stream');

        const downloadLink = document.createElement('a');
        downloadLink.href = image;
        downloadLink.download = `QrCodeUnico.png`;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      });
    },

    cleanTable() {
      swal({
        title: this.$t('newAction.stepThree.messages.deleteList.title'),
        text: this.$t('newAction.stepThree.messages.deleteList.description'),
        icon: 'warning',
        buttons: true,
        dangerMode: true,
      }).then(async (willDelete) => {
        if (willDelete) {
          if (this.submitFile) {
            this.submitFile = null;
          }

          this.insertedItems = [];
        }
      });
    },

    insertItem() {
      const form = document.querySelector('#frm-newUser');

      const obj = serialize(form, { hash: true });

      this.insertedItems.push(obj);

      swal({
        title: this.$t('newAction.stepThree.messages.addClientSuccess.title'),
        text: this.$t(
          'newAction.stepThree.messages.addClientSuccess.description',
        ),
        icon: 'success',
      });
    },

    routerPath(path) {
      this.$router.push(path);
    },

    downloadModel() {
      this.downloadQrcodeFile({
        token: this.userAuth.token,
        columns: this.columns,
      });
    },

    makeToastInvalidName(append = false) {
      this.toastCount += 1;
      this.$bvToast.toast(
        this.$t('newAction.stepThree.messages.errors.invalidCharacters'),
        {
          title: this.$t('newAction.stepThree.titleAddIndicator'),
          autoHideDelay: 5000,
          appendToast: append,
          variant: 'danger',
        },
      );
    },

    makeToastColumnName(append = false) {
      this.toastCount += 1;
      this.$bvToast.toast(
        this.$t('newAction.stepThree.messages.errors.invalidColumn'),
        {
          title: this.$t('newAction.stepThree.titleAddIndicator'),
          autoHideDelay: 5000,
          appendToast: append,
          variant: 'danger',
        },
      );
    },

    makeToastInvalidNameId(append = false) {
      this.toastCount += 1;
      this.$bvToast.toast(this.$t('newAction.stepThree.invalidIdField'), {
        title: this.$t('newAction.stepThree.titleAddIndicator'),
        autoHideDelay: 5000,
        appendToast: append,
        variant: 'danger',
      });
    },
  },

  async mounted() {
    const multiple = document.getElementById('template-multiple');
    const unique = document.getElementById('template-unique');

    multiple.style.display = 'none';
    unique.style.display = 'block';

  },
};
</script>

<style lang="scss">
.ellipsis {
  color: #c1c1c1;
}

.ellipsis:hover {
  cursor: all-scroll;
}

.qrcode-title {
  text-transform: uppercase;
  font-size: 21px;
  font-weight: 100;
  color: #bdbdbd;
}

.header {
  display: flex;
  flex-direction: row;

  .header-icon-qrcode {
    float: left;
    font-size: 12px;
    margin-top: 8px;
    padding-right: 12px;
    color: #bdbdbd;
  }
}
</style>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';

td,
th {
  text-align: center;
}

td:first-child,
th:first-child {
  text-align: left;
}

.footer-buttons-area {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.wrapper {
  background-color: #fff;
  border: 1px solid $gray-light;
  padding: 8px 24px;
  border-radius: 4px;
  margin: 8px;
}

.vue-step-wrapper {
  background-color: #fff;
  border: 1px solid $gray-light;
  padding: 0 24px;
  border-radius: 4px;
  margin: 8px 8px 16px;
}
</style>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';

button {
  &:hover {
    color: $white;
  }
}

.indicator-th {
  position: relative;
}

.indicator-info-icon {
  margin-left: 5px;
  position: absolute;
  top: 12px;
}

.main-qrcode {
  padding-top: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/actions/prepare-qr-code/index.vue